export default "__VITE_ASSET__DO5FKcnh__"